import React, { Component, useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { GatsbyImage } from "gatsby-plugin-image"
import { useMediaQuery } from 'react-responsive'
import { MIN_DEFAULT_MQ } from "../utils/presets"

const CarouselContainer = styled(`div`)({
  position: `relative`,
  width: `100%`,
  [MIN_DEFAULT_MQ]: {
    height: `544px`
  }
})

const CarouselWrapper = styled(`div`)({
  position: `relative`,
  width: `100%`,
  display: `flex`,
  flexDirection: `column`,
})

const CarouselContentWrapper = styled(`div`)({
  [MIN_DEFAULT_MQ]: {
    overflow: `hidden`,
    width: `100%`,
    height: `100%`,
  }
})

const CarouselContent = styled(`div`)({
  display: `flex`,
  flexDirection: `column`,
  [MIN_DEFAULT_MQ]: {
    flexDirection: `row`
  },
  transition: `all 250ms linear`,
  // -ms-overflow-style: none;  /* hide scrollbar in IE and Edge */
  // scrollbar-width: none;  /* hide scrollbar in Firefox */
  [`*`]: {
    // width: `100%`,
    flexShrink: 0,
    flexGrow: 1
  },
  [`::-webkit-scrollbar`]: {
    display: `none`
  }
})

const ImageWrapper = styled(`div`)({
  padding: `0 0 1rem 0`,
  [MIN_DEFAULT_MQ]: {
    width: `800px`,
    padding: `0 1rem 0 0`
  }
})

const Controls = styled(`div`)({
  position: `absolute`,
  top: `-3rem`,
  right: `2rem`,
  display: `none`,
  padding: `1rem 0`,
  [MIN_DEFAULT_MQ]: {
    display: `flex`,
    justifyContent: `space-between`
  },
  [`div`]: {
    paddingRight: `1rem`
  },
  [`button`]: {
    padding: 0,
    background: `transparent`,
    color: `#fff`,
    border: `none`,
    cursor: `pointer`,
    textTransform: `uppercase`
  }
})

const Carousel = ({ images }) => {

  // MQs
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" })

  const [currentIndex, setCurrentIndex] = useState(0)
  const [length, setLength] = useState(images && images.length)

  // Set the length to match current children from props
  useEffect(() => {
    images && setLength(images.length)
  }, [images])

  const next = () => {
    if (currentIndex < (length - 1)) {
      setCurrentIndex(prevState => prevState + 1)
    }
  }

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prevState => prevState - 1)
    }
  }

  const count = images && images.length > 0 ? images.length : 0

  return (
    <CarouselContainer>
    {
      images && images.length > 0 &&
        <Controls>
          <div>{`${currentIndex + 1} / ${count}`}</div>
          <button onClick={prev}>Prev</button> <span>&nbsp;/&nbsp;</span> <button onClick={next}>Next</button>
        </Controls>
    }
    {
      images && images.length > 0
        ? (
        <CarouselWrapper>
          <CarouselContentWrapper>
            <CarouselContent
              style={{ transform: `translateX(-${currentIndex * 814}px)` }}
            >
              {images.map((image, index) => <ImageWrapper key={index}><GatsbyImage image={image} alt=""/></ImageWrapper>)}
            </CarouselContent>
          </CarouselContentWrapper>
        </CarouselWrapper>
      ) : <ImageWrapper><GatsbyImage image={images} alt=""/></ImageWrapper>
    }
    </CarouselContainer>
  )
}

export default Carousel
